import React from 'react';
import { QrReader } from 'react-qr-reader';
import {basicHandleError, handleAlert} from "../../services/AlertService";
import {saveProfileInLocalStorage, submitShift} from "../../services/AuthService";
import {changeQRorderStatus} from "../../services/admin/OrderService";
import {useTranslation} from "react-i18next";

const QRcodeReader = (props) => {
  const { t } = useTranslation();

  function toggleWorking(shift) {
    submitShift(shift).then((response) => {
      saveProfileInLocalStorage(response.data.profile);
    }).catch((error) => {
      basicHandleError(error.response.data.errors);
    });
  }

  function handleScan(data) {
    if (!!data) {
      if (data.text === 'shift') {
        toggleWorking(true)
      } else if (data.text === 'unshift') {
        toggleWorking(false)
      } else if (data.text.includes('cooked') && !props.action) {
        const [status, id] = data.text.split("-");
        changeQRorderStatus(id, status).then((resp) => {
          const order = resp.data.order;
          handleAlert('success', `Замовлення ${order.id}`, t(`orderStatuses.${order.status}`))
        }).catch((error) => basicHandleError(error.response.data.errors))
      } else if (!!props.action) {
        if (props.checking.includes(data.text)) {
          props.action()
        } else {
          basicHandleError(['Неправильний QR код'])
        }
      } else {
        window.location.href = data
      }
    }
  }

  return (
    <div>
      <div style={{ width: '300px', height: '300px', margin: '0 auto' }}>
        <QrReader
          onResult={(result) => {
            if (!!result) {
              handleScan(result)
            }
          }}
          constraints={{ facingMode: 'environment' }}
        />
      </div>
    </div>
  );
};

export default QRcodeReader;